import { FraudulentTransactionDetailsStatus } from 'commons/models/confiscation.model';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import { CONFISCATION_RESOURCES } from '../submodules/selectConfiscation/helper';

export const makeActionList = (params: any) => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Reject',
				id: 'reject',
				isEnabled: (rowData: any) => {
					const { status } = rowData;
					if (
						status === FraudulentTransactionDetailsStatus.PENDING ||
						status === FraudulentTransactionDetailsStatus.APPROVED ||
						status === FraudulentTransactionDetailsStatus.REJECTED
					) {
						return false;
					}

					return hasPermissionV2({
						configPageName: PAGE_NAMES.miscellaneous,
						configResourceName: MISCELLANEOUS_RESOURCES.confiscationAndRefund,
						configActionName: ACTION.updateConfiscationAndRefundRequest
					});
				}
			},
			{
				name: 'Approve',
				id: 'approve',
				isEnabled: (rowData: any) => {
					const { status } = rowData;
					if (
						status === FraudulentTransactionDetailsStatus.PENDING ||
						status === FraudulentTransactionDetailsStatus.APPROVED ||
						status === FraudulentTransactionDetailsStatus.REJECTED
					) {
						return false;
					}

					return hasPermissionV2({
						configPageName: PAGE_NAMES.miscellaneous,
						configResourceName: MISCELLANEOUS_RESOURCES.confiscationAndRefund,
						configActionName: ACTION.updateConfiscationAndRefundRequest
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermissionV2({
					configPageName: MISCELLANEOUS_RESOURCES.confiscationAndRefund,
					configResourceName: CONFISCATION_RESOURCES.manualConfiscation,
					configActionName: ACTION.createConfiscationAndRefundRequest
				});
			}
		}
	};
};

export default {
	makeActionList
};
